import React, { useState, useEffect } from 'react'
import Select from 'react-select'

import { loadCauses, loadSubCauses } from '../api/causes';

export const IncidentCreatorStepThree = (props)=>{
    //Load the causes possibilities
    let [causes, setCauses] = useState([])
    const [subCauses, setSubCauses] = useState([]);

    let [selectedCauseOption, setSelectedCauseOption] = useState({"cause_id": "", "cause_description": ""})
    const [selectedSubCauseOption, setSelectedSubCauseOption] = useState({"subcause_id": "", "subcause_description": ""});
    let [selectedCauses, setSelectedCauses] = useState([])

    useEffect(()=>{
        loadCauses().then((resp)=>{
            var options = []
            resp.map((cause)=>{
                options.push({
                    value: cause['cause_id'],
                    label: cause['cause_description']
                })
            })
            setCauses(options)
        });

        loadSubCauses().then((resp) => {
            setSubCauses(resp.map(sc => ({ value: sc['subcause_id'], label: sc['subcause_description'], parent: sc['cause_id'] })));
        });
    }, [])

    useEffect(()=>{
        setSelectedCauses(props.selectedCauses)
    }, [props.selectedCauses])

    if(props.currentStep!==3){
        return null
    }

    var causeDropdownChanged = option =>{
        const {label, value}=option

        setSelectedSubCauseOption(null);
        setSelectedCauseOption({...selectedCauseOption, cause_id: value, cause_description: label})
    }

    const subCauseDropdownChanged = option => {
        const { label, value } = option;
        setSelectedSubCauseOption({ ...selectedSubCauseOption, subcause_id: value, subcause_description: label });
    }

    var incidentCauseDescriptionChanged = evt =>{
        const {label, value} = evt.target;
        setSelectedCauseOption({...selectedCauseOption, incident_cause_description: value})

    }

    var addNewCause = ()=>{
        if(selectedCauseOption.cause_id!==""){
            props.causeCallback(selectedCauseOption, selectedSubCauseOption)
            setSelectedCauseOption({
                "cause_id": "",
                "cause_description": "",
                "incident_cause_description": ""
            })
            setSelectedSubCauseOption(null);
        }
        else{
            alert("A valid cause should be provided.")
        }
    }

    return(
        <div className='subFormPart'>
            <h4>Incident causes</h4>
            <div className='selection-area' id="select-causes">
                <div className="form-group">
                    <label htmlFor="cause-dropdown">Select a cause (you can add multiple to this incident)</label>
                    <Select 
                        name="cause-dropdown" 
                        options={causes.filter(x => !selectedCauses.some(y => y.cause_id === x.value))} 
                        value={selectedCauseOption ? causes.find(c => c.value === selectedCauseOption.cause_id) || null : null}
                        onChange={causeDropdownChanged}
                        />
                </div>
                <div className="form-group">
                    <label htmlFor="subcause-dropdown">Select a subcause</label>
                    <Select 
                        name="subcause-dropdown" 
                        isDisabled={!selectedCauseOption || !selectedCauseOption.cause_id}
                        options={selectedCauseOption ? subCauses.filter(sc => sc.parent === selectedCauseOption.cause_id) || [] : []}
                        value={selectedSubCauseOption ? subCauses.find(sc => sc.value === selectedSubCauseOption.subcause_id) || null : null}
                        onChange={subCauseDropdownChanged}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="incident-cause-description">Extra description about cause</label>
                    <textarea type="text" className="form-control" value={selectedCauseOption?.incident_cause_description} onChange={incidentCauseDescriptionChanged} name="incident-cause-description"/>
                </div>
                <div className='form-group'>
                    <a className='btn btn-secondary' onClick={addNewCause}>Add cause</a>
                </div>
            </div> 
            <div id="selected-incident-causes" className='selected-area'>
                <h5>Selected causes</h5>
                <div id="selected-causes">
                    <table>
                        <tr>
                            <th>Cause</th>
                            <th>Subcause</th>
                            <th>Description</th>
                            <th>Actions</th>
                        </tr>
                        {selectedCauses.map((selectedCause)=>{
                            return (
                                <tr className='selectedCauseEntry' key={`${selectedCause.cause_id}_${selectedCause.subcause_id}`}>
                                    <td>{selectedCause.cause_description}</td>
                                    <td>{selectedCause.subcause_description}</td>
                                    <td>{selectedCause.incident_cause_description}</td>
                                    <td><a className="btn btn-danger" onClick={()=>{props.removeCauseCallback(selectedCause.cause_id, selectedCause.subcause_id)}}>Delete</a></td>
                                </tr>
                            )
                        })}
                    </table>
                </div>
            </div>
        </div>
    )
}